document.documentElement.classList.remove('no-js');

const syncWholesaleAccountLinks = (root = document) => {
  const accountUrl = document.body?.dataset.wholesaleAccountUrl;
  if (!accountUrl) return;
  root.querySelectorAll?.('a').forEach((link) => {
    const label = link.textContent.trim().toLowerCase();
    if (label === 'open a wholesale account' || label === 'sign in to apply for wholesale access') link.href = accountUrl;
  });
};

syncWholesaleAccountLinks();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
    if (node.nodeType === Node.ELEMENT_NODE) syncWholesaleAccountLinks(node);
  }));
}).observe(document.body, { childList: true, subtree: true });

const formatMoney = (cents, format = '${{amount}}') => {
  const value = (Number(cents || 0) / 100).toFixed(2);
  const clean = value.endsWith('.00') ? value.slice(0, -3) : value;
  return format.replace('{{amount}}', clean).replace('{{amount_no_decimals}}', Math.round(Number(cents || 0) / 100));
};

let cartToastTimer;
const showCartToast = (message, isError = false) => {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  const messageNode = toast.querySelector('[data-cart-toast-message]');
  if (messageNode) messageNode.textContent = message;
  toast.classList.toggle('is-error', isError);
  toast.hidden = false;
  window.clearTimeout(cartToastTimer);
  cartToastTimer = window.setTimeout(() => { toast.hidden = true; }, 4200);
};

const updateCartCount = (cart) => {
  document.querySelectorAll('[data-cart-count]').forEach((count) => {
    count.textContent = cart.item_count;
    count.hidden = cart.item_count === 0;
  });
};

const updateVolumePricing = (root, subtotal) => {
  if (!root || root.dataset.exclusiveAccountPrice === 'true') return;
  const tierOne = Number(root.dataset.orderTierOne || 0);
  const tierTwo = Number(root.dataset.orderTierTwo || 0);
  let activeTier = 'opening';
  if (tierTwo > 0 && subtotal >= tierTwo) activeTier = 'partner';
  else if (tierOne > 0 && subtotal >= tierOne) activeTier = 'preferred';
  root.querySelectorAll('[data-volume-tier]').forEach((tier) => {
    tier.classList.toggle('is-current', tier.dataset.volumeTier === activeTier);
  });
};

const getCart = async () => {
  const rootPath = window.Shopify?.routes?.root || '/';
  const response = await fetch(`${rootPath}cart.js`, {headers: {Accept: 'application/json'}});
  if (!response.ok) throw new Error('Unable to load cart');
  return response.json();
};

const rememberPopup = (modal) => {
  const days = Number(modal.dataset.frequencyDays || 1);
  try { localStorage.setItem(modal.dataset.popupKey, String(Date.now() + days * 86400000)); } catch (_) {}
};

const canShowPopup = (modal) => {
  try { return Number(localStorage.getItem(modal.dataset.popupKey) || 0) < Date.now(); } catch (_) { return true; }
};

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const opening = menu?.hidden;
    if (menu) menu.hidden = !opening;
    document.querySelectorAll('[data-menu-toggle]').forEach((button) => button.setAttribute('aria-expanded', String(opening)));
    document.body.classList.toggle('menu-open', Boolean(opening));
  }

  const modalOpen = event.target.closest('[data-open-modal]');
  if (modalOpen) {
    const modal = document.getElementById(modalOpen.dataset.openModal);
    if (modal) {
      modal.hidden = false;
      document.body.classList.add('modal-open');
      modal.querySelector('input,button,textarea')?.focus();
    }
  }

  const modalClose = event.target.closest('[data-close-modal]');
  if (modalClose || event.target.matches('.kv-modal')) {
    const modal = event.target.closest('.kv-modal');
    if (modal) {
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      if (modal.dataset.popupKey) rememberPopup(modal);
    }
  }

  const mobileAdd = event.target.closest('[data-mobile-add]');
  if (mobileAdd) document.querySelector('[data-product-form]')?.requestSubmit();

  const imageOpen = event.target.closest('[data-product-image-open]');
  if (imageOpen) {
    const productRoot = imageOpen.closest('[data-product-root]');
    const lightbox = productRoot?.querySelector('[data-product-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-product-lightbox-image]');
    if (lightbox && lightboxImage) {
      lightboxImage.src = imageOpen.dataset.imageSrc;
      lightboxImage.alt = imageOpen.dataset.imageAlt || '';
      lightboxImage.hidden = false;
      lightbox.showModal();
      document.body.classList.add('modal-open');
    }
  }

  const imageClose = event.target.closest('[data-product-image-close]');
  if (imageClose) imageClose.closest('[data-product-lightbox]')?.close();

  if (event.target.matches('[data-product-lightbox]')) event.target.close();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modal = document.querySelector('.kv-modal:not([hidden])');
    if (modal) {
      modal.hidden = true;
      document.body.classList.remove('modal-open');
      if (modal.dataset.popupKey) rememberPopup(modal);
    }
  }
});

document.querySelectorAll('[data-product-root]').forEach((root) => {
  const form = root.querySelector('[data-product-form]');
  const idInput = form?.querySelector('input[name="id"]');
  const price = root.querySelector('[data-product-price]');
  const mobilePrice = root.querySelector('[data-mobile-price]');
  const compare = root.querySelector('[data-compare-price]');
  const priceBadge = root.querySelector('[data-price-badge]');
  const add = root.querySelector('[data-add-to-cart]');
  const mobileAdd = root.querySelector('[data-mobile-add]');
  const selectedWeights = root.querySelectorAll('[data-selected-weight]');
  const selectedSku = root.querySelector('[data-selected-sku]');
  const selectedSkuTop = root.querySelector('[data-selected-sku-top]');
  const selectedLengths = root.querySelectorAll('[data-selected-length]');
  const volumeUnit = root.querySelector('[data-volume-unit]');
  const volumeTierOne = root.querySelector('[data-volume-tier-one]');
  const volumeTierTwo = root.querySelector('[data-volume-tier-two]');
  const volumeAccount = root.querySelector('[data-volume-account]');
  const hasExclusiveAccountPrice = root.dataset.exclusiveAccountPrice === 'true';
  const format = root.dataset.moneyFormat || '${{amount}}';
  const addLabel = root.dataset.addLabel || 'Add to order';
  const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';

  updateVolumePricing(root, Number(root.dataset.cartSubtotal || 0));

  root.querySelectorAll('[data-variant-card]').forEach((card) => {
    const cardContent = card.innerHTML;
    const restoreCardContent = () => {
      if (card.hasAttribute('hidden')) card.removeAttribute('hidden');
      if (!card.querySelector('.variant-card__length')) card.innerHTML = cardContent;
    };
    const cardContentObserver = new MutationObserver(restoreCardContent);
    cardContentObserver.observe(card, { childList: true, attributes: true, attributeFilter: ['hidden'] });

    card.addEventListener('click', (event) => {
      event.preventDefault();
      if (card.disabled) return;
      root.querySelectorAll('[data-variant-card]').forEach((item) => {
        item.classList.remove('is-selected');
        item.setAttribute('aria-pressed', 'false');
      });
      card.classList.add('is-selected');
      card.setAttribute('aria-pressed', 'true');
      if (idInput) idInput.value = card.dataset.variantId;
      const basePrice = formatMoney(card.dataset.price, format);
      const newPrice = hasExclusiveAccountPrice ? card.dataset.accountPrice : basePrice;
      if (price) price.textContent = newPrice;
      if (mobilePrice) mobilePrice.textContent = newPrice;
      if (compare) {
        compare.textContent = hasExclusiveAccountPrice ? basePrice : (card.dataset.comparePrice ? formatMoney(card.dataset.comparePrice, format) : '');
        compare.hidden = !hasExclusiveAccountPrice && !card.dataset.comparePrice;
      }
      if (priceBadge) priceBadge.hidden = !hasExclusiveAccountPrice && !card.dataset.comparePrice;
      const nextWeight = card.dataset.weight && card.dataset.weight !== '—' ? card.dataset.weight : '--';
      selectedWeights.forEach((item) => { item.textContent = nextWeight; });
      if (selectedSku) selectedSku.textContent = card.dataset.sku || '—';
      if (selectedSkuTop) selectedSkuTop.textContent = card.dataset.sku || '—';
      const nextLength = card.dataset.length && card.dataset.length !== '—' ? card.dataset.length : card.dataset.title || '--';
      selectedLengths.forEach((item) => { item.textContent = nextLength; });
      if (volumeUnit) volumeUnit.textContent = newPrice;
      if (volumeTierOne) volumeTierOne.textContent = card.dataset.orderTierOnePrice;
      if (volumeTierTwo) volumeTierTwo.textContent = card.dataset.orderTierTwoPrice;
      if (volumeAccount) volumeAccount.textContent = card.dataset.accountPrice;
      const available = card.dataset.available === 'true';
      if (add) {
        add.disabled = !available;
        add.querySelector('span').textContent = available ? addLabel : soldOutLabel;
      }
      if (mobileAdd) {
        mobileAdd.disabled = !available;
        mobileAdd.textContent = available ? addLabel : soldOutLabel;
      }
      restoreCardContent();
      window.requestAnimationFrame(restoreCardContent);
    });
  });

  form?.addEventListener('submit', async (event) => {
    if (event.submitter?.name && event.submitter.name !== 'add') return;
    event.preventDefault();
    const submitButton = event.submitter || add;
    const formData = new FormData(form);
    const variantId = Number(formData.get('id'));
    const quantity = Number(formData.get('quantity') || 1);
    if (!variantId || quantity < 1) return;

    const wasDisabled = Boolean(submitButton?.disabled);
    if (submitButton) submitButton.disabled = true;
    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({items: [{id: variantId, quantity}]})
      });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await getCart();
      updateCartCount(cart);
      document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
        productRoot.dataset.cartSubtotal = cart.items_subtotal_price;
        updateVolumePricing(productRoot, Number(cart.items_subtotal_price || 0));
      });
      const toast = document.querySelector('[data-cart-toast]');
      showCartToast(toast?.dataset.successMessage || 'Item added to your order.');
    } catch (_) {
      const toast = document.querySelector('[data-cart-toast]');
      showCartToast(toast?.dataset.errorMessage || "We couldn't add that item. Please try again.", true);
    } finally {
      if (submitButton) submitButton.disabled = wasDisabled;
    }
  });
});

getCart().then((cart) => {
  updateCartCount(cart);
  document.querySelectorAll('[data-product-root]').forEach((root) => {
    root.dataset.cartSubtotal = cart.items_subtotal_price;
    updateVolumePricing(root, Number(cart.items_subtotal_price || 0));
  });
}).catch(() => {});

document.querySelectorAll('[data-product-lightbox]').forEach((lightbox) => {
  lightbox.addEventListener('close', () => {
    document.body.classList.remove('modal-open');
    const lightboxImage = lightbox.querySelector('[data-product-lightbox-image]');
    if (lightboxImage) {
      lightboxImage.hidden = true;
      lightboxImage.removeAttribute('src');
    }
  });
});

document.querySelectorAll('[data-wholesale-cart-form]').forEach((form) => {
  form.addEventListener('submit', (event) => {
    const cartPage = form.closest('[data-minimum-order]');
    const submitter = event.submitter;
    if (!cartPage || submitter?.name !== 'checkout') return;
    if (Number(cartPage.dataset.cartTotal || 0) < Number(cartPage.dataset.minimumOrder || 0)) event.preventDefault();
  });
});

const popupQueue = [];
let popupActive = false;
const runPopupQueue = () => {
  if (popupActive || !popupQueue.length) return;
  const modal = popupQueue.shift();
  if (!canShowPopup(modal)) return runPopupQueue();
  popupActive = true;
  modal.hidden = false;
  document.body.classList.add('modal-open');
  const observer = new MutationObserver(() => {
    if (modal.hidden) {
      observer.disconnect();
      popupActive = false;
      setTimeout(runPopupQueue, 350);
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
};

document.querySelectorAll('[data-email-popup]').forEach((modal) => {
  modal.querySelector('form')?.addEventListener('submit', () => rememberPopup(modal));
  const delay = Math.max(0, Number(modal.dataset.delay || 0)) * 1000;
  setTimeout(() => {
    if (canShowPopup(modal)) popupQueue.push(modal);
    runPopupQueue();
  }, delay);
});

const loadMetalMarket = async (market) => {
  const baseUrl = market.dataset.providerUrl.replace(/\/$/, '');
  const priceNodes = {
    XAU: market.querySelector('[data-metal-price="XAU"]'),
    XAG: market.querySelector('[data-metal-price="XAG"]')
  };
  const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });
  try {
    const responses = await Promise.all(['XAU', 'XAG'].map((symbol) => fetch(`${baseUrl}/${symbol}`, { headers: { Accept: 'application/json' } })));
    if (responses.some((response) => !response.ok)) throw new Error('Market data unavailable');
    const quotes = await Promise.all(responses.map((response) => response.json()));
    quotes.forEach((quote) => {
      if (priceNodes[quote.symbol] && Number.isFinite(Number(quote.price))) priceNodes[quote.symbol].textContent = formatter.format(Number(quote.price));
    });
    const status = market.querySelector('[data-metal-status]');
    if (status) status.textContent = `Indicative USD spot · updated ${quotes[0]?.updatedAtReadable || 'now'}`;
  } catch (_) {
    if (priceNodes.XAU) priceNodes.XAU.textContent = market.dataset.goldFallback;
    if (priceNodes.XAG) priceNodes.XAG.textContent = market.dataset.silverFallback;
  }
};

document.querySelectorAll('[data-live-metal-market]').forEach((market) => {
  loadMetalMarket(market);
  const interval = Math.max(5, Number(market.dataset.refreshMinutes || 5)) * 60000;
  setInterval(() => loadMetalMarket(market), interval);
});


document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-mega-toggle]');
  if (toggle) {
    const item = toggle.closest('[data-mega-item]');
    const opening = !item?.classList.contains('is-open');
    document.querySelectorAll('[data-mega-item].is-open').forEach((openItem) => {
      if (openItem !== item) {
        openItem.classList.remove('is-open');
        openItem.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
      }
    });
    item?.classList.toggle('is-open', opening);
    toggle.setAttribute('aria-expanded', String(opening));
  } else if (!event.target.closest('[data-mega-item]')) {
    document.querySelectorAll('[data-mega-item].is-open').forEach((item) => {
      item.classList.remove('is-open');
      item.querySelector('[data-mega-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('[data-mega-item].is-open').forEach((item) => {
    item.classList.remove('is-open');
    const toggle = item.querySelector('[data-mega-toggle]');
    toggle?.setAttribute('aria-expanded', 'false');
    toggle?.focus();
  });
});
